export const SPECS = {
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseConvertedPricesInExpress: 'specs.ecom.UseConvertedPricesInExpress',
  ExpressNavigateToCheckoutWithDirectURLParams: 'specs.ecom.ExpressNavigateToCheckoutWithDirectURLParams'
};
//# sourceMappingURL=SPECS.js.map